import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Clock } from 'lucide-react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    // Initialize or get end time from localStorage
    const storedEndTime = localStorage.getItem('offerEndTime');
    let endTime: number;
    if (storedEndTime) {
      endTime = parseInt(storedEndTime, 10);
      // If time has passed, reset for another 24 hours
      if (Date.now() > endTime) {
        endTime = Date.now() + 24 * 60 * 60 * 1000;
        localStorage.setItem('offerEndTime', endTime.toString());
      }
    } else {
      endTime = Date.now() + 24 * 60 * 60 * 1000;
      localStorage.setItem('offerEndTime', endTime.toString());
    }
    const timer = setInterval(() => {
      const now = Date.now();
      const difference = endTime - now;
      if (difference <= 0) {
        // Reset if time is up
        const newEndTime = Date.now() + 24 * 60 * 60 * 1000;
        localStorage.setItem('offerEndTime', newEndTime.toString());
        return;
      }
      const hours = Math.floor(difference / (1000 * 60 * 60) % 24);
      const minutes = Math.floor(difference / 1000 / 60 % 60);
      const seconds = Math.floor(difference / 1000 % 60);
      setTimeLeft({
        hours,
        minutes,
        seconds
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 w-full bg-[#2d5016] text-white py-3 px-4 shadow-md" data-id="element-172">
      <div className="max-w-6xl mx-auto flex justify-center items-center gap-2 text-sm md:text-base font-medium" data-id="element-173">
        <Clock className="w-4 h-4 md:w-5 md:h-5 animate-pulse text-[#8bc34a]" data-id="element-174" />
        <p data-id="element-175">
          ⏰ Oferta termina en:{' '}
          <span className="font-bold font-mono tracking-wider text-[#8bc34a]" data-id="element-176">
            {formatTime(timeLeft.hours)}:{formatTime(timeLeft.minutes)}:
            {formatTime(timeLeft.seconds)}
          </span>
        </p>
      </div>
    </div>;
}